import React from 'react';
import { ConfigProvider, theme } from 'antd';
import koKR from 'antd/locale/ko_KR';
import 'antd/dist/reset.css';

// Layout Components
import MainLayout from '../components/layout/MainLayout';

// Context Providers
import { AppProvider } from '../contexts/AppContext';
import { ReferenceDataProvider } from '../contexts/ReferenceDataContext';

const BossManagementPage: React.FC = () => {
  return (
    <ConfigProvider 
      locale={koKR}
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#1890ff',
          colorBgContainer: '#141414',
          colorBgElevated: '#1f1f1f',
          colorBgLayout: '#0a0a0a',
        },
      }}
    >
      <AppProvider>
        <ReferenceDataProvider>
          <MainLayout />
        </ReferenceDataProvider>
      </AppProvider>
    </ConfigProvider>
  );
};

export default BossManagementPage;